function nn(v) {
    return v !== null && v !== undefined;
}

const supportsLocaleOptions = !!(typeof Intl === 'object' && Intl && typeof Intl.NumberFormat === 'function');

let _locale = undefined;

function numberLocale() {
    // const _locale = Cookies.get('_locale') || undefined;
    return _locale;
}

function _toLocaleString(val) {
    if (supportsLocaleOptions) {
        return val.toLocaleString(numberLocale());
    }
    return val.toLocaleString();
}

function _toLocaleStringWithDecimalPlaces(val, minDecimalPlaces, maxDecimalPlaces) {
    if (supportsLocaleOptions) {
        if (minDecimalPlaces) minDecimalPlaces = Math.min(minDecimalPlaces, 20);
        if (minDecimalPlaces) maxDecimalPlaces = Math.min(maxDecimalPlaces, 20);

        return val.toLocaleString(numberLocale(), {
            minimumFractionDigits: minDecimalPlaces,
            maximumFractionDigits: maxDecimalPlaces
        });
    }
    return val.toFixed(maxDecimalPlaces);
}

function toLocaleString(value, options) {
    const num = Number(value);
    if (isNaN(num)) {
        return value;
    }
    const minDecimalPlaces = options && options.minDecimalPlaces;
    const maxDecimalPlaces = options && options.maxDecimalPlaces;
    if (minDecimalPlaces === undefined || maxDecimalPlaces === undefined) {
        return _toLocaleString(num);
    }
    return _toLocaleStringWithDecimalPlaces(num, minDecimalPlaces, maxDecimalPlaces);
}

function isNumber(n) {
    return (n !== null && typeof n === 'number' && !isNaN(n));
}

const expPattern = new RegExp(/(\d+)\.?(\d*)e([+-]*)(\d+)/i);
const fixedPattern = new RegExp(/\d+\.?(\d*)/i);

export class Numbers {
    static toLocaleString(value, options) {
        return toLocaleString(value, options);
    }

    static toFixed(n) {
        const precision = Numbers.getPrecision(n);
        if (precision === null) {
            return null;
        }

        let toLocaleStringOpts = undefined;
        if (precision > 0) {
            toLocaleStringOpts = {minDecimalPlaces: precision, maxDecimalPlaces: precision};
        }

        return toLocaleString(n, toLocaleStringOpts);
    }

    static toPrecision(n, precision) {
        if (!isNumber(n)) {
            return '';
        }
        return Numbers.toFixed(Number.parseFloat(n.toPrecision(precision)));
    }

    static isNumber(n) {
        return isNumber(n);
    }

    static toPerc2(value) {
        if (isNumber(value)) {
            return toLocaleString(value * 100, {minDecimalPlaces: 2, maxDecimalPlaces: 2}) + '%';
        }
        return '';
    }

    static toInt(value) {
        if (isNumber(value)) {
            return toLocaleString(Math.round(value));
        }
        return '';
    }

    static toDecimals(value, decimals) {
        if (!decimals) {
            decimals = 2;
        }
        const toLocaleStringOpts = {minDecimalPlaces: decimals, maxDecimalPlaces: decimals};
        return toLocaleString(value, toLocaleStringOpts);
    }

    static toMaxDecimals(value, decimals) {
        const toLocaleStringOpts = {minDecimalPlaces: 0, maxDecimalPlaces: decimals};
        return toLocaleString(value, toLocaleStringOpts);
    }

    static getPrecision(n) {
        if (!nn(n)) {
            return null;
        }
        if (typeof n === 'string') {
            n = parseFloat(n);
        }
        if (!isNumber(n)) {
            return null;
        }

        let str = n.toString();
        // https://gist.github.com/jiggzson/b5f489af9ad931e3d186

        const expMatch = expPattern.exec(str);
        if (expMatch) {
            const coefficientFractionDigits = (expMatch[2] !== null ? expMatch[2].length : 0);
            const mantissaFractionCorrection = (expMatch[3] === '-' ? -1 : 1) * parseInt(expMatch[4]);
            return coefficientFractionDigits - mantissaFractionCorrection;
        }

        const fixedMatch = fixedPattern.exec(str);
        if (fixedMatch) {
            return (fixedMatch[1] !== null ? fixedMatch[1].length : 0);
        }

        return 0;
    }

    static useLocale(locale) {
        _locale = locale;
    }
}